<template>
  <div :class="{'hideleft':hide === true}" class="page">
    <div class="crumb-container">
      <ol class="breadcrumb">
        <li>
          <a href="javascript:;" class="crumb-home z-font-size-14">账户</a>
        </li>
        <li>
          <a href="javascript:;" class="z-font-size-14">绑定微信</a>
        </li>
      </ol>
    </div>
    <div class="page-main z-padding-h-20-precent">
      <div class="panel-heading">
        <div class="panel-title">绑定微信</div>
      </div>
      <div class="panel-body">
        <div class="alert-warn">
          账号后，您可以使用微信进行扫码登录、延期、账户管理等操作。
        </div>
        <el-card class="box-card" v-loading="listLoading" style="min-height: 450px;">
          <div v-if="bind == true" class="ub-box">
            <i class="icon-wexin"></i>
            <div class="z-lineHeight-20">
              <p class="z-font-size-18 z-color-666">微信绑定成功</p>
              <p class="z-font-size-14 z-color-999 z-margin-top-5-precent">您可以使用进行便捷操作，如需取消绑定点击下面取消按钮</p>
            </div>
          </div>
          <div v-if="bind == true" class="ub-box z-margin-left-50-precent z-margin-top-25-precent z-margin-bottom-10-precent">
            <div class="ub-row">
              <p class="z-font-size-14 z-color-000">微信账号：{{nickname}}</p>
              <div class="weixin-container">
                <img :src="src" alt="微信头像" width="118" height="118">
              </div>
            </div>
            <div class="ub-align-self-end z-padding-left-25-precent">
              <el-button type="primary" @click="unBind">取消绑定</el-button>
            </div>
          </div>
          <div v-if="!bind" class="ub-box">
            <i class="icon-wexin"></i>
            <div class="z-lineHeight-20">
              <p class="z-font-size-18 z-color-666">扫码绑定微信</p>
              <p class="z-font-size-14 z-color-999 z-margin-top-5-precent">使用微信扫一扫功能，扫描下面的二维码进行绑定。</p>
            </div>
          </div>
          <div v-if="!bind" class="ub-box ub-wrap z-margin-left-50-precent z-margin-top-15-precent z-margin-bottom-50-precent">
            <div class="erweima-container">
              <img :src="url_gz" alt="关注二维码">
              <p class="z-margin-top-15-precent z-font-size-18 z-color-000">第一步：关注公众号</p>
              <p class="z-margin-top-10-precent z-color-999">如已关注请忽略</p>
            </div>
            <div class="erweima-container z-margin-left-50-precent">
              <img :src="url_bind" alt="绑定二维码" >
              <p class="z-margin-top-15-precent z-font-size-18 z-color-000">第二步：绑定二维码</p>
            </div>
          </div>
        </el-card>
      </div>
    </div>
  </div>
</template>
<script>
  import { MessageBox } from 'element-ui';
  import Xbutton from 'commons/Xbutton.vue'
  import userService from 'business/userService.js'
  export default {
    data () {
      return {
        listLoading:false,
        bind:Boolean,
        state:'',
        nickname:'',
        src:'',
        url_bind:'',
        url_gz:'',
      }
    },
    props:{
      hide:Boolean
    },
    created() {
      this.timer = setInterval(() => {
        this.checkBind()
      }, 2000)
    },
    mounted(){
      this.checkBindF()
    },
    beforeDestroy() {
      if(this.timer) { //如果定时器还在运行 或者直接关闭，不用判断
        clearInterval(this.timer); //关闭
      }
    },
    methods: {
      async checkBindF() {
        this.listLoading = true
        let data = 'cmd=check_wx_bind'
        let {vueData, state} = await userService.transformToVue('userInfo','POST',data)
        if(state.code === '000' ) {
          if(vueData.response == 200) {
            this.listLoading = false
            this.bind = true
            this.state = vueData.msg
            this.src = vueData.msg.headimgurl
            this.nickname = vueData.msg.nickname
          }else {
            this.bind = false
            let self = this
            setTimeout(() => {
              self.listLoading = false
            }, 2000)
            this.url_bind = vueData.url_bind
            this.url_gz = vueData.url_gz
          }
        }else {
          this.$toast(vueData.msg,'fail')
        }
      },
      async checkBind() {
        let data = 'cmd=check_wx_bind'
        let {vueData, state} = await userService.transformToVue('userInfo','POST',data)
        if(state.code === '000' ) {
          if(vueData.response == 200) {
            clearInterval(this.timer)
            this.bind = true
            this.state = vueData.msg
            this.src = vueData.msg.headimgurl
            this.nickname = vueData.msg.nickname
          }else {
            this.bind = false
            this.url_bind = vueData.url_bind
            this.url_gz = vueData.url_gz
          }
        }else {
          this.$toast(vueData.msg,'fail')
        }
      },
      async unBind() {
        MessageBox.confirm('您确定取消绑定吗?', '确认', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          lockScroll: false,
          type: 'warning'
        }).then(async() => {
          let data = 'cmd=del_wx_bind'
          this.dialogLoading = true
          let {vueData, state} = await userService.transformToVue('userInfo','POST',data)
          if(vueData.response == 200 ) {
            this.dialogLoading = false
            let self = this
            this.$dialog({type:'success', info: vueData.msg, click () {
                self.checkBindF()
                self.timer = setInterval(() => {
                  self.checkBind()
                }, 2000)
              }})
          }else {
            this.dialogLoading = false
            this.$dialog({type:'error', info: vueData.msg, click () {

              }})
          }
        }).catch(() => {

        })
      },
    }
  }
</script>
<style scoped>
  .hideleft { margin-left: 80px; }
  a {
    text-decoration: none;
  }
  .crumb-home {
    padding-left: 28px;
    background: url(../../assets/imgs/zhanghu.png) no-repeat left center;
  }
  .alert-warn {
    margin-bottom: 30px;
  }
  .icon-wexin {
    display: inline-block;
    width: 48px;
    height: 42px;
    background: url(../../assets/imgs/weix.png) no-repeat center;
    margin-right: 12px;
    margin-top: 1px;
  }
  .weixin-container {
    margin-top: 10px;
    width: 118px;
    height: 118px;
    border: 1px solid #c4c4c4;
    padding: 10px;
    text-align: center;
  }
  .erweima-container {
    margin-top: 10px;
    width: 258px;
    height: 258px;
    border: 1px solid #c4c4c4;
    padding: 10px;
    text-align: center;
  }
</style>






// WEBPACK FOOTER //
// src/pages/user/weixin.vue